import React from 'react'
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
} from 'reactstrap'
import moment from 'moment'
import { ReservePlanDto } from '../../../../api-dtos/support/merchant/reserve-plan.dto.interface'

interface ReservePlanCardProps {
  reservePlan: ReservePlanDto | null
  onEditPlan: () => void
  onDeletePlan: () => void
  onCreatePlan: () => void
}

const ReservePlanCard: React.FC<ReservePlanCardProps> = ({
  reservePlan,
  onEditPlan,
  onDeletePlan,
  onCreatePlan,
}) => {
  return (
    <Card className="mb-4">
      <CardHeader>
        <Row className="align-items-center">
          <Col>
            <CardTitle className="h4 mb-0">Reserve Plan</CardTitle>
          </Col>
          <Col xs="auto">
            {reservePlan ? (
              <div>
                <Button
                  color="primary"
                  size="sm"
                  onClick={onEditPlan}
                  className="me-2"
                >
                  Edit Plan
                </Button>
                <Button color="danger" size="sm" onClick={onDeletePlan}>
                  Delete Plan
                </Button>
              </div>
            ) : (
              <Button color="success" size="sm" onClick={onCreatePlan}>
                Create Reserve Plan
              </Button>
            )}
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        {reservePlan ? (
          <Row>
            <Col md={3}>
              <div className="text-center p-3 border rounded">
                <h4 className="text-primary mb-1">{reservePlan.percent}%</h4>
                <small className="text-muted">Reserve Percentage</small>
              </div>
            </Col>
            <Col md={3}>
              <div className="text-center p-3 border rounded">
                <h4 className="text-primary mb-1">{reservePlan.minimumDays}</h4>
                <small className="text-muted">Minimum Days</small>
              </div>
            </Col>
            <Col md={3}>
              <div className="text-center p-3 border rounded">
                <h4 className="mb-1 text-primary">
                  {reservePlan.status.toUpperCase()}
                </h4>
                <small className="text-muted">Status</small>
              </div>
            </Col>
            <Col md={3}>
              <div className="text-center p-3 border rounded">
                <h4 className="mb-1 text-primary">
                  {moment(reservePlan.createdAt).format('Do MMM, YYYY')}
                </h4>
                <small className="text-muted d-block">Created</small>
              </div>
            </Col>
          </Row>
        ) : (
          <div className="text-center text-muted">
            <p>No reserve plan configured for this merchant.</p>
            <p className="small">
              Create a reserve plan to automatically hold a percentage of
              payments for dispute management.
            </p>
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default ReservePlanCard
